import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import CardsContainer from "@/components/CardsContainer";
import CardsList from "@/components/CardsList";
import CardsTable from "@/components/CardsTable";
import VLFModal from "@/components/Modal";

import {CompetitionAPI} from "@/api/competition";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import {SUCCESSFUL_OPERATION, ERROR_OPERATION} from "@/utils/constants";

import "./index.scss";

function CompetitionsPage(props) {
	const {handleNotification} = props;

	const navigate = useNavigate();

	const [loading, setLoading] = useState(false);
	const [competitions, setCompetitions] = useState([]);

	const [id, setId] = useState();
	const [openHandleConfirm, setOpenHandleConfirm] = useState(false);

	const getCompetitions = async () => {
		setLoading(true);
		try {
			const response = await CompetitionAPI.list();
			setCompetitions(response);
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading(false);
		}
	};

	const deleteCompetition = async () => {
		setLoading(true);
		try {
			await CompetitionAPI.delete(id);
			getCompetitions();
			handleNotification(SUCCESSFUL_OPERATION, "success");
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
			setLoading(false);
		} finally {
			setOpenHandleConfirm(false);
		}
	};

	useEffect(() => {
		getCompetitions();
	}, []);

	const listConfiguration = {
		data: competitions,
		imageUrl: () => require("@/assets/images/coach/match.png"),
		title: (competition) => competition.name,
		subtitle: (competition) => competition.competitionType,
		actions: [
			{
				icon: <EditIcon />,
				variant: "outlined",
				title: "Modifica",
				onClick: (competition) =>
					navigate("/settings/competitions/" + competition.id + "/edit"),
			},
			{
				icon: <DeleteIcon />,
				variant: "outlined",
				title: "Elimina",
				onClick: (competition) => {
					setId(competition.id);
					setOpenHandleConfirm(true);
				},
				color: "error",
			},
		],
	};

	const columns = [
		{label: "Nome", key: "name", align: "start"},
		{label: "Tipologia", key: "competitionType", align: "start"},
	];

	const headerActions = [
		{
			icon: <AddIcon />,
			title: "Nuova competizione",
			onClick: () => navigate("/settings/competitions/new"),
		},
	];

	return (
		<Page>
			<Loading visible={loading} />
			<Breadcrumbs
				current="Competizioni"
				actions={<MainActions actions={headerActions} />}
			/>
			<CardsContainer
				tableComponent={
					<CardsTable
						breadcrumbs
						configurationColumns={columns}
						data={competitions}
						fullWidth
						rowActions
						handleEdit={(item) =>
							navigate("/settings/competitions/" + item.id + "/edit")
						}
						handleDelete={(item) => {
							setId(item.id);
							setOpenHandleConfirm(true);
						}}
						defaultSortedField="name"
					/>
				}
				listComponent={
					<CardsList
						breadcrumbs
						listConfiguration={listConfiguration}
						defaultSortedField="name"
					/>
				}
			/>
			<VLFModal
				open={openHandleConfirm}
				title="Eliminazione"
				content={
					<div className="mt-2">
						Sei sicuro di voler eliminare questa competizione?
					</div>
				}
				confirm={deleteCompetition}
				close={() => setOpenHandleConfirm(false)}
				confirmLabel="Conferma"
			/>
		</Page>
	);
}

export default CompetitionsPage;
